import React from "react";

function Particles() {
  return (
    <div className="particles" aria-hidden="true">
      <span /><span /><span /><span /><span /><span /><span /><span />
    </div>
  );
}

export default Particles;
